import { Controller } from "@hotwired/stimulus"
import TomSelect  from "tom-select"
import TomSelect_remove_button from 'tom-select/dist/js/plugins/remove_button.js';

TomSelect.define('remove_button', TomSelect_remove_button);

require("tom-select/dist/css/tom-select.bootstrap4.css")

export default class extends Controller {
  static targets = ["selectable"]

  static values = {
    createOptionUrl: String,
    createOptions: { type: Boolean, default: false },
    persistOptions: { type: Boolean, default: false },
  }

  connect(){
    let settings = {
      plugins: ['remove_button'],
      persist: this.persistOptionsValue,
      closeAfterSelect: true,
      createOnBlur: true,
      create: (value, data) => {
        let select = this.selectableTarget.tomselect
        // TODO: remove data hardcoding
        let jsonData = JSON.stringify({ variant_type_value: { name: value } })
        let fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: jsonData
        }
        fetch(this.createOptionUrlValue, fetchOptions)
          .then(response => {
            if (!response.ok) {
              console.error('could not create value')
            }
            return response.json()
          })
        .then(json => {
          let idValue = String(json[0].id)
          if (idValue !== undefined) {
            select.addOption({ 'value': idValue, 'text': value }, true)
            select.addItem(idValue)
          } else {
            alert('Could not create value')
          }
        })
      },
      onOptionAdd: this.createOption
    }
    this.selectableTargets.forEach(el => new TomSelect(el, settings))
  }
}
